<template>
  <div
      class="order-status-content">
    <div
        class="order-status-bullet"
        :class="'order-status-bullet-' + statusNameBullet.replace(' ', '-').toLowerCase()">
    </div>
    <div
        class="order-status-cards"
        shadow="never"
        style="border-radius: 4px !important; border: 1px solid #dee5ec;">
      <div class="order-status-info">
        <div
            class="order-status-name">
          {{ statusName }}
        </div>
        <div class="order-status-subtext">
          <div
              v-if="statusNameBullet === CANCELLED || statusNameBullet == ORDER_RECEIVED">
            {{ subtext }}
          </div>
          <div
              v-if="statusNameBullet === SHIPPED">
            UPS:  <a
                :href="`https://www.swiship.com/track/?id=${subtext}`"
                target="_blank">{{ subtext }}</a>
          </div>
          <div
              v-if="statusNameBullet === RETURN_CREATED">
            <!--TODO: Add return details link when return details flow is complete-->
            Return  <a
                href=""
                @click.prevent="openPopup(subtext)">
              #{{ subtext }}
            </a>
          </div>
          <div
              v-if="subtext2 !== null">
            {{ subtext2 }}
          </div>
        </div>
        <div class="order-status-datetime">
          {{ dateTimeWithTimezone | moment("MMM DD, YYYY [at] hh:mm A") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import ReturnOrderDetails from "./Return/ReturnOrderDetails.vue";
import "../../../assets/order_timeline_status.css";

export default {
  name: "OrderTimelineStatus",
  components: { ReturnOrderDetails },
  props: {
    statusName: {
      type: String,
      default: "Processing",
    },
    subtext: {
      type: String,
      default: "doorbell",
    },
    dateTime: {
      type: String,
      default: "doorbell",
    },
    subtext2: {
      type: String,
      default: "",
    },
    returnId: {
      type: String,
      default: "",
    },
    returnCreated: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const SHIPPED = "Shipped",
      ORDER_RECEIVED = "Order Received",
      CANCELLED = "Cancelled",
      RETURN_CREATED = "Return Created";
    return {
      statusNameBullet: "",
      SHIPPED,
      ORDER_RECEIVED,
      CANCELLED,
      RETURN_CREATED,
      dateTimeWithTimezone: "",
      visible: false,
    };
  },
  mounted() {
    this.getStatusNameBulletClass();
    let tz = this.$store.getters["ui/currentTimezone"];
    this.dateTimeWithTimezone = this.$moment
      .tz(this.dateTime, tz)
      .format("MMM DD, YYYY [at] hh:mm A");
  },
  methods: {
    exitOrderDetails(value) {
      this.visible = false;
    },
    openPopup(value) {
      this.$emit("return-created", true);
      this.$emit("return-id", value);
    },
    moment,
    getStatusNameBulletClass() {
      if (this.statusName.startsWith("Shipped")) {
        this.statusNameBullet = "Shipped";
      } else this.statusNameBullet = this.statusName;
    },
  },
};
</script>
